module.exports = __webpack_public_path__ + "img/quicklink-tiles-hyundai.4344d792.png";